'use strict';

var createReactContext = require('create-react-context');

var AriaMenuButtonManagerContext = createReactContext();

module.exports = AriaMenuButtonManagerContext;